var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuboEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ADB5BD;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:0.64;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2_",
    className: "st0",
    cx: 300.1,
    cy: 300.1,
    r: 286.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    className: "st1",
    d: "M258.5,109.9V128c0,0-68.4-22.3-108.4,44.1C150.1,172.1,158.4,89.3,258.5,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    className: "st1",
    d: "M358.5,111.1v15.6c0,0,75.7-16.1,107.4,46.1C465.9,172.8,460.8,90.9,358.5,111.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_57_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st1",
    d: "M398.2,371.2c-1.2,64.4,6.9,118.2,18.1,120.1c11.2,2,36.1-46,55.6-107.1 c19.5-61.1,11.4-114.9-18.1-120.1C424.3,258.9,399.4,306.8,398.2,371.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_54_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    className: "st1",
    d: "M208.4,372.4c-1.2,64.4-11.4,117.8-22.6,119.4c-11.3,1.5-34.3-47.3-51.5-109.2 c-17.2-61.8-7.1-115.3,22.6-119.3C186.6,259.1,209.6,308,208.4,372.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st1",
    d: "M460.2,327.9c-13.6,90.9-96.5,210.3-156.8,210.3c-60.4,0-145.8-119.4-162.7-210.3 c-16.9-90.8,66-150.8,156.8-150.8S473.9,237,460.2,327.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st1",
    d: "M342,515.2c0,4.5-2.6,11-5,16c-2.1,4.3-5.9,4.3-8,0c-2.4-5.1-5-11.6-5-16 c0-8.3,4-15.1,9-15.1S342,506.9,342,515.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st1",
    d: "M368.5,515.2c0,4.5-2.6,11-5,16c-2.1,4.3-5.9,4.3-8,0c-2.4-5.1-5-11.6-5-16 c0-8.3,4-15.1,9-15.1C364.5,500.2,368.5,506.9,368.5,515.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st1",
    d: "M354.3,515.2c0,4.5-2.6,11-5,16c-2.1,4.3-5.9,4.3-8,0c-2.4-5.1-5-11.6-5-16 c0-8.3,4-15.1,9-15.1C350.2,500.2,354.3,506.9,354.3,515.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st1",
    d: "M252.6,515.2c0,4.5-2.6,11-5,16c-2.1,4.3-5.9,4.3-8,0c-2.4-5.1-5-11.6-5-16 c0-8.3,4-15.1,9-15.1C248.6,500.2,252.6,506.9,252.6,515.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st1",
    d: "M279,515.2c0,4.5-2.6,11-5,16c-2.1,4.3-5.9,4.3-8,0c-2.4-5.1-5-11.6-5-16 c0-8.3,4-15.1,9-15.1C275,500.2,279,506.9,279,515.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st1",
    d: "M264.8,515.2c0,4.5-2.6,11-5,16c-2.1,4.3-5.9,4.3-8,0c-2.4-5.1-5-11.6-5-16 c0-8.3,4-15.1,9-15.1C260.8,500.2,264.8,506.9,264.8,515.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st1",
    d: "M225.4,393.2c4-15.5,20.5-34.7,30.9-33.7c10.5,1.1,23.2,23.3,24.5,39.4 c1.3,16.1-14.1,25-29.9,23.3C235.2,420.6,221.4,408.7,225.4,393.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st1",
    d: "M273.9,396.1c2.4-15.8,16.8-36.6,27.3-36.6c10.5,0,25.4,20.8,28.4,36.6 c2.9,15.8-11.5,26.3-27.3,26.3C286.4,422.4,271.5,411.9,273.9,396.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st1",
    d: "M177.3,388.2c6.6-14.6,26.3-30.6,36.4-27.7c10.1,2.9,18.7,27,17.2,43 c-1.5,16-18.3,22.1-33.5,17.7C182.1,416.9,170.6,402.8,177.3,388.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st1",
    d: "M373.9,405.7c-3.4-15.6,2.7-40.2,12.5-44c9.8-3.7,31.2,10.4,39.5,24.2 c8.4,13.8-1.4,28.7-16.2,34.3C394.9,425.8,377.3,421.3,373.9,405.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st1",
    d: "M324.2,402.9c-1.6-15.9,7.2-39.7,17.3-42.3c10.2-2.6,29.8,13.8,36.6,28.4 c6.8,14.6-4.6,28.3-19.9,32.3C342.9,425.2,325.9,418.8,324.2,402.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st1",
    d: "M241.2,425.6c3.1-12.1,15.9-27.1,24.1-26.2c8.1,0.8,18,18.1,19.1,30.6 c1,12.5-11,19.4-23.3,18.2C248.8,446.9,238.1,437.6,241.2,425.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st1",
    d: "M279,427.8c1.9-12.3,13.1-28.5,21.3-28.5c8.2,0,19.8,16.2,22.1,28.5 c2.3,12.3-9,20.5-21.3,20.5C288.8,448.3,277.2,440.1,279,427.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st1",
    d: "M203.7,421.7c5.2-11.3,20.4-23.8,28.3-21.6c7.9,2.3,14.6,21,13.4,33.5 c-1.2,12.5-14.2,17.2-26.1,13.8C207.5,444,198.6,433,203.7,421.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_26_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st1",
    d: "M356.9,435.3c-2.7-12.2,2.1-31.3,9.7-34.2c7.7-2.9,24.3,8.1,30.8,18.8 c6.5,10.7-1.1,22.3-12.6,26.7C373.2,450.9,359.5,447.5,356.9,435.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st1",
    d: "M318.2,433.1c-1.3-12.4,5.6-30.9,13.5-32.9c7.9-2,23.2,10.8,28.5,22.1 c5.3,11.4-3.6,22.1-15.5,25.1C332.7,450.5,319.5,445.5,318.2,433.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_23_",
    className: "st1",
    cx: 214.1,
    cy: 269.7,
    rx: 70.7,
    ry: 64.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_22_",
    className: "st1",
    cx: 214.1,
    cy: 253.6,
    rx: 53.4,
    ry: 48.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st1",
    d: "M239.4,212l-31.3,66.4l72.6-20.6C280.7,257.8,276.7,225.5,239.4,212z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_18_",
    className: "st1",
    cx: 397.1,
    cy: 269.7,
    rx: 70.7,
    ry: 64.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_17_",
    className: "st1",
    cx: 397.1,
    cy: 252,
    rx: 53.4,
    ry: 48.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st1",
    d: "M424.8,212.3l-31.5,67.8l71.8-21C465.2,259.1,458.1,226.4,424.8,212.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st1",
    d: "M339.5,289.1c0,16.8-30.9,47.8-30.9,47.8s-30.9-31-30.9-47.8c0-16.8,13.9-30.4,30.9-30.4 C325.6,258.7,339.5,272.3,339.5,289.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st1",
    d: "M350.2,193.7c-13.1,5.4-28.5,13.1-41.7,13.1c-13.1,0-28.6-7.7-41.7-13.1 c-35.3-14.6-124.2-24-180.5-1.4l1.7,39.1c0,0,10.2-2.8,13.6,11.3c3.4,14.1,11.2,72.4,25.6,95.2c17.8,28.3,56.2,29.4,82.1,28 c34.9-1.9,57.8-21.4,67.6-54.3c9.8-33,15.3-38.4,21.5-47.3c3.4-4.8,7.2-5.2,10.1-5.2c3,0,6.8,0.4,10.1,5.2 c6.2,9,11.8,14.3,21.5,47.3c9.8,33,32.6,52.4,67.6,54.3c25.9,1.4,64.3,0.3,82.1-28c14.3-22.8,22.2-81,25.6-95.2 c3.4-14.1,13.6-11.3,13.6-11.3l1.7-39.1C474.4,169.7,385.5,179.1,350.2,193.7 M261.2,311.5c-9.4,22.1-25.1,33.4-48.8,37.2 c-23.6,3.8-51.9-2-66.2-12.7c-12.5-9.4-18.6-39.1-21.6-57c-3-17.9-8.3-56.5,6.4-69.2c14.6-12.7,51.4-13.7,75.8-11.8 c18.4,1.4,58.2,7.5,65.7,25.4C280,241.3,268.8,293.6,261.2,311.5 M492.4,279c-3,17.9-9.1,47.6-21.6,57 c-14.3,10.7-42.5,16.5-66.2,12.7c-23.6-3.8-39.4-15.1-48.8-37.2c-7.6-17.9-18.8-70.2-11.3-88.1c7.5-17.9,47.3-24,65.7-25.4 c24.4-1.9,61.2-0.9,75.8,11.8C500.7,222.5,495.4,261.1,492.4,279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st2",
    d: "M261.2,311.5c-9.4,22.1-25.1,33.4-48.8,37.2c-23.6,3.8-51.9-2-66.2-12.7 c-12.5-9.4-18.6-39.1-21.6-57c-3-17.9-8.3-56.5,6.4-69.2c14.6-12.7,51.4-13.7,75.8-11.8c18.4,1.4,58.2,7.5,65.7,25.4 C280,241.3,268.8,293.6,261.2,311.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st2",
    d: "M492.4,279c-3,17.9-9.1,47.6-21.6,57c-14.3,10.7-42.5,16.5-66.2,12.7 c-23.6-3.8-39.4-15.1-48.8-37.2c-7.6-17.9-18.8-70.2-11.3-88.1c7.5-17.9,47.3-24,65.7-25.4c24.4-1.9,61.2-0.9,75.8,11.8 C500.7,222.5,495.4,261.1,492.4,279"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuboEmpty);
export default __webpack_public_path__ + "static/media/bubo-empty.9de8cc91bc9db7d216d85ebc2f743230.svg";
export { ForwardRef as ReactComponent };